import React, { Component } from 'react';

const ProviderMessages = () => {
	return ( <h1>Provider Messages</h1> );
}
 
export default ProviderMessages;